import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { SecondaryTextButton } from '@bibliocommons/base-buttons';
import { bindAll } from '@bibliocommons/utils-react';
import { libraryShape, routerShape } from '@bibliocommons/bc-prop-types';

import { scopeShape } from 'app/shapes/search';
import updateSearchQuery from 'app/helpers/search/updateSearchQuery.js';
import BroadenSearchInfoPopOver from 'app/components/search/BroadenSearchInfoPopOver';

import './BroadenSearchButton.scss';

export class BroadenSearchButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  getSearchURL(query) {
    const { router } = this.props;

    const newQuery = updateSearchQuery({
      currentQuery: router.query,
      page: undefined,
      lastSearchScope: router.query.searchScope,
      ...query
    });

    return { query: newQuery };
  }

  handleBroadenClick() {
    const { isBroadened, searchType, broadenedSearchType, router, library } = this.props;
    const lastSearchScope = router.query.lastSearchScope;

    if (searchType !== 'keyword') {
      const href = this.getSearchURL({
        searchType: 'keyword',
        searchScope: isBroadened && lastSearchScope
      });
      return this.props.router.push(href);
    }

    if (broadenedSearchType && !isBroadened) {
      const newScope = library.get('broadenScope', false) ? { searchScope: this.getBroadenedScope() } : {};

      const href = this.getSearchURL({
        ...newScope,
        searchType: broadenedSearchType
      });

      return this.props.router.push(href);
    }

    return null;
  }

  getBroadenedScope() {
    const { scopes } = this.props;
    return scopes && scopes.first() && scopes.first().get('scopeId');
  }

  render() {
    const { isBroadened, broadenedSearchType, searchType, query } = this.props;

    const label = searchType !== 'keyword' ? 'form_label_expand_to_keyword' : 'empty_broaden_your_search';

    const validSearchType = !['keyword', 'bl'].includes(searchType);
    const canBroaden = broadenedSearchType;
    if (validSearchType || canBroaden || isBroadened) {
      return (
        <div className="cp-broaden-search-button">
          <SecondaryTextButton
            dataKey="broaden-search-button"
            handleClick={this.handleBroadenClick}
            className="broaden-search-button"
          >
            <FormattedMessage id={label} values={{ query }} />
          </SecondaryTextButton>
          {(validSearchType || canBroaden) && searchType === 'keyword' && <BroadenSearchInfoPopOver />}
        </div>
      );
    }

    return null;
  }
}

BroadenSearchButton.displayName = 'BroadenSearchButton';

BroadenSearchButton.propTypes = {
  broadenedSearchType: PropTypes.string,
  isBroadened: PropTypes.bool,
  router: routerShape,
  query: PropTypes.string,
  searchType: PropTypes.string,
  scopes: ImmutablePropTypes.listOf(scopeShape),
  library: libraryShape
};

export default BroadenSearchButton;
